<template>
	<ECommercePreConfigBundle
		:bundleType="content?.bundleType"
		:readyForProduction="content?.readyForProduction"
	/>
</template>
<script>
import GizmoComponentMixin from "~/mixins/platform/GizmoComponentMixin.js";
export default defineNuxtComponent({
	name: "GizmoECommercePreConfigBundle",
	mixins: [GizmoComponentMixin],
});
</script>
<style lang="scss" scoped></style>
